import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './App.css';
import Home from './Home.js';
import Team from './Team.js';
import Tutorial from './Tutorial.js';
import { useState } from "react";

function App() {

  const [page, setPage] = useState(<Home />);
  function changePage(e) {
    var elementId = e.target.id;
    if (elementId === "Home") {
      setPage(<Home />);
    } else if (elementId === "Tutorial") {
      setPage(<Tutorial />);
    } else {
      setPage(<Team />);
    }
  }

  return (
    <div>
      <header className="App-header">
        <div className="row w-100 text-center">
          <div id="Home" className="col-4" onClick={changePage}>Home</div>
          <div id="Tutorial" className="col-4" onClick={changePage}>Tutorial</div>
          <div id="Team" className="col-4" onClick={changePage}>The Team</div>
        </div>
      </header>
      {page}
    </div>
  );
}

export default App;
